interface AvatarProps {
  name?: string;
  size?: number;
}

function initials(name: string): string {
  if (!name.trim()) return '?';
  const parts = name.trim().split(/[\s\-_.]+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name = '', size = 36 }: AvatarProps) {
  const fontSize = Math.max(10, Math.floor(size / 2) - 2);
  return (
    <div className="avatar" style={{ width: size, height: size, fontSize }}>
      {initials(name)}
    </div>
  );
}
